import SquidGames from "./squid_games_404_bg.png";

export const DEFAULT_404 = {
  displayTitle: "404",
  title: null,
  body: {
    json: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: "Red light! This page is not moving.",
              nodeType: "text",
            },
          ],
          nodeType: "paragraph",
        },
      ],
      nodeType: "document",
    },
    __typename: "ContentType404PageBody",
  },
  background: {
    url: SquidGames,
    contentType: "image/jpeg",
  },
  buttonText: null,
};
